export default __webpack_public_path__ + "a0a52b85f97929125933d5632eb7bed0.png";